import {UI} from "../../../stem-core/ui/UIBase";
import {StyleSheet} from "../../../stem-core/ui/Style";
import {registerStyle} from "../../../stem-core/ui/style/Theme";
import {styleRule} from "../../../stem-core/decorators/Style";
import {isSmallScreen} from "../../Utils";
import {Device} from "../../../stem-core/base/Device";


class WidgetScrimStyle extends StyleSheet {
    @styleRule
    container = {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 3,
        borderRadius: () => isSmallScreen() && !Device.isLandscape() ? 0 : 12,
        background: this.themeProps.MERCHANT_SCRIM_BACKGROUND,
        opacity: 0,
        transition: this.themeProps.DEFAULT_TRANSITION_DURATION_MS,
    };

    @styleRule
    visible = {
        opacity: 1,
    };
}

@registerStyle(WidgetScrimStyle)
export class WidgetScrim extends UI.Element {
    hide(timeout) {
        this.removeClass(this.styleSheet.visible);
        this.attachTimeout(() => this.destroyNode(), timeout);
    }

    onMount() {
        super.onMount();
        this.attachTimeout(() => this.addClass(this.styleSheet.visible));
    }
}
